import {TicketDto} from "./ticket.dto";
import {TicketTypeObjectRoleDto} from "./ticket-type-object-role.dto";
import {DtoDetail} from "../../../../../core/shared/dto/dto.detail";
import {ObjectTypeDto} from "../../../../../core/cc/model/dto/entity/object-type.dto";

export class TicketObjectDto extends DtoDetail {


    public ticketDto? : TicketDto;
    public ticketDtoId : number;
    public ticketDtoName : string;
    public objectTypeDto? : ObjectTypeDto;
    public objectTypeDtoId : number;
    public objectTypeDtoName : string;
    public objectId: number;
    public ticketTypeObjectRoleDto? : TicketTypeObjectRoleDto;
    public ticketTypeObjectRoleDtoId : number;
    public ticketTypeObjectRoleDtoName : string;
    public uiIsMainTicketObject : boolean;

}